import React, { useState, useEffect, useRef } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { RxHamburgerMenu } from 'react-icons/rx';
import logo from '../Images/logo.png';
import { Link } from 'react-router-dom';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef(null);
    const buttonRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                isMenuOpen &&
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                !buttonRef.current.contains(event.target)
            ) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMenuOpen]);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <div className='w-full h-full flex flex-col justify-between'>
            <div className="flex justify-between items-center bg-black p-4 md:p-6">
                <Link to="/">
                    <img src={logo} alt='logo' className="h-14 w-auto text-white text-2xl font-bold" />
                </Link>
                <div className="flex items-center space-x-4 z-30">
                    <button
                        ref={buttonRef}
                        onClick={toggleMenu}
                        className={`hover:bg-[#1a1a1a]/80 text-white text-3xl p-2 rounded-full transition-transform duration-300 ease-in-out ${isMenuOpen ? 'rotate-45' : ''}`}
                    >
                        {isMenuOpen ? <AiOutlinePlus /> : <RxHamburgerMenu />}
                    </button>
                </div>
                {isMenuOpen && (
                    <div
                        ref={menuRef}
                        className={`z-20 text-white fixed top-0 right-0 h-screen flex flex-col justify-center items-center w-2/3 md:w-1/3 bg-black opacity-90 backdrop-blur-3xl transform transition-transform duration-300 ease-in-out ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}
                    >
                        <div className="p-8">
                            <ul className="space-y-3">
                                {['expertise', 'projects', 'studio', 'people', 'careers', 'contact'].map((item) => (
                                    <li key={item}>
                                        <Link to={`/${item}`}>
                                            <button
                                                onClick={toggleMenu}
                                                className="w-full py-3 px-4 text-2xl md:text-3xl rounded-lg transition duration-300 ease-in-out transform hover:font-semibold"
                                            >
                                                {item.charAt(0).toUpperCase() + item.slice(1)}
                                            </button>
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {/* <div className='flex justify-between space-x-8 bottom-0 text-white text-3xl md:text-4xl'>
                            <a href="https://www.instagram.com/architetivedesigns?igsh=MTV4eGIyeTlreGZ0cQ==">
                                <FaInstagram className='p-1 rounded-lg bg-transparent hover:bg-gradient-to-tr from-[#fdbf60] via-[#d72c78] to-[#9034b5]' />
                            </a>
                            <a href="https://www.facebook.com/share/1Aqcj3DFFa/">
                                <FaFacebook className='p-1 rounded-lg bg-transparent hover:bg-[#0866ff]' />
                            </a>
                            <a href="https://www.linkedin.com/in/architetive-designs-18279934a">
                                <RiLinkedinFill className='p-1 rounded-lg bg-transparent hover:bg-[#0077B5]' />
                            </a>
                            <a href="https://www.youtube.com/channel/UC7a1glo22K08gE_GGxP3oqQ">
                                <FaYoutube className='p-1 rounded-lg bg-transparent hover:bg-[#ff0000]' />
                            </a>
                            <a href="https://x.com/ArchitetiveD">
                                <FaTwitter className='p-1 rounded-lg bg-transparent hover:bg-[#1DA1F2]' />
                            </a>
                        </div> */}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Header;